import React, { ReactElement, FC } from "react";
import {
  PageApplication,
  PageApplications,
  PageMainRoute,
  PageProfile,
  PageReports,
} from "../views/indexPage";
import PrivateRoute from "../utils/HOC/PrivateRoute";
import { Route, Routes } from "react-router-dom";
import Component404 from "../components/Component404/Component404";
import { useAppSelector } from "../store/reduxHooks";
import { nanoid } from "nanoid";
import { SELECT_ROUTINIG } from "../store/selectors/routingSelector";

interface IPages {
  [key: string]: ReactElement;
}

export const AppRoutes: FC = () => {
  const routingSlice = useAppSelector(SELECT_ROUTINIG);

  const ROUTS_ELEMENT: IPages = {
    PageApplications: <PageApplications />,
    PageReports: <PageReports />,
    PageProfile: <PageProfile />,
    Application: <PageApplication />,
  };

  return (
    <>
      <PrivateRoute>
        <Routes>
          <Route path={"/"} element={<PageMainRoute routes={routingSlice} />}>
            {routingSlice?.map((routeGroup) => {
              const { routes } = routeGroup;
              return routes?.map((route) => {
                const element = ROUTS_ELEMENT[route.element];
                const ID = nanoid();
                const link = route.to;
                if (link === "application") {
                  return (
                    <Route key={ID} path={route.to} element={element}>
                      <Route
                        key={ID + "application"}
                        path={
                          ":applicationId/applicationBank/:applicationBankId"
                        }
                        element={<PageApplication />}
                      />
                    </Route>
                  );
                }
                return (
                  <Route key={ID} path={"/" + route.to} element={element} />
                );
              });
            })}
          </Route>
          <Route path="*" element={<PageMainRoute routes={routingSlice} />}>
            <Route path="*" element={<Component404 />} />
          </Route>
        </Routes>
      </PrivateRoute>
    </>
  );
};
